import app from 'app';

export default class EmbedmentController {
  static confirmLeave() {
    const isReEditing = sessionStorage.getItem('reEditEmbedded');
    return isReEditing ? this.confirmLeaveReEdit() : this.confirmLeaveDraft();
  }

  static confirmLeaveDraft() {
    const story = app.storyController.story;
    return new Promise((resolve, reject) => {
      app.dialog
        .confirm({
          type: app.dialog.types.CONFIRM_2,
          title: 'Do you want to save this draft?',
          buttonYesText: 'Yes, save',
          buttonNoText: 'No, delete this draft',
          buttonNoAction: 'delete',
        })
        .then((data) => {
          if (!data.action) {
            // stay
            reject();
          } else if (data.action === 'delete') {
            // delete the story & exit
            const id = story.get('id');

            app.delayedSpinner.show();

            app.api.draftStories
              .delete({ id, template: story.get('template') })
              .fail(() => {
                console.error(`failed deleting story ${id}`);
                app.delayedSpinner.hide();
                app.dialog.error({
                  type: app.dialog.types.ERROR_1,
                  title: 'Failed deleting story',
                  description: 'Please try again or contact support',
                  showContactCsm: true,
                });
                reject();
              })
              .done(() => {
                resolve(false);
              });
          } else {
            // keep the story & exit
            resolve(true);
          }
        });
    });
  }

  static confirmLeaveReEdit() {
    return new Promise((resolve, reject) => {
      const shouldConfirm = !(
        app.remoteStash.get('hideBack2ShortcutConfirm') ?? false
      );

      if (shouldConfirm) {
        app.dialog
          .confirm({
            type: app.dialog.types.CONFIRM_1,
            title: 'Your draft video is saved.',
            description: 'You can continue editing it anytime.',
            buttonYesText: 'OK',
            checkboxLabel: app.culture.confirmPopup.doNotShowAgain,
            showCheckbox: true,
          })
          .then((data) => {
            if (data.action) {
              if (data.metadata.checkboxValue) {
                app.remoteStash.set('hideBack2ShortcutConfirm', true);
              }
              resolve(true);
            } else {
              reject();
            }
          });
      } else {
        resolve(true);
      }
    });
  }
}
